import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1.5 text-sm">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {item.to ? (
            <Link
              to={item.to}
              className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium">{item.label}</span>
          )}
          {index < items.length - 1 && (
            <i className="ri-arrow-right-s-line text-foreground-300"></i>
          )}
        </span>
      ))}
    </nav>
  );
}